import React, { useEffect, useState } from 'react';
import './ImageSlider.css';

interface ImageSliderProps {
  images: string[];
  autoSlideInterval: number;
}

const ImageSlider: React.FC<ImageSliderProps> = ({ images, autoSlideInterval }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [intervalId, setIntervalId] = useState<NodeJS.Timeout | null>(null);
  const [visibleImages, setVisibleImages] = useState(1);

  useEffect(() => {
    const updateVisibleImages = () => {
      if (window.innerWidth < 600) {
        setVisibleImages(1);
      } else {
        setVisibleImages(4);
      }
    };

    updateVisibleImages();

    window.addEventListener('resize', updateVisibleImages);

    return () => {
      window.removeEventListener('resize', updateVisibleImages);
    };
  }, []);

  useEffect(() => {
    const interval = createInterval();
    return () => clearInterval(interval);
  }, [images.length, autoSlideInterval]);

  const repeatImages = (images: string[], count: number) => {
    if (images.length <= 0) return;
    const repeated = [];
    while (repeated.length < count) {
      repeated.push(...images);
    }
    return repeated.slice(0, count);
  };

  const createInterval = () => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, autoSlideInterval);
    setIntervalId(interval);
    return interval;
  };

  const repeatedImages = repeatImages(images, Math.max(visibleImages, images.length));

  const displayedImages = [];
  if (repeatedImages) {
    for (let i = 0; i < visibleImages; i++) {
      displayedImages[i] = repeatedImages[(currentIndex + i) % repeatedImages.length];
    }
  }
  const goToNextSlide = () => {
    if (intervalId) clearInterval(intervalId);
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    createInterval();
  };

  const goToPrevSlide = () => {
    if (intervalId) clearInterval(intervalId);
    setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
    createInterval();
  };

  return (
    <div className="slider-container">
      <div className="slider">
        {displayedImages.map((image, index) => (
          <div className="slide" key={index}>
            <img src={image} alt={`Slide ${index}`} />
          </div>
        ))}
      </div>

      <button className="nav-button prev" onClick={goToPrevSlide}>❮</button>
      <button className="nav-button next" onClick={goToNextSlide}>❯</button>

      <div className="dot-indicators">
        {images.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === currentIndex ? 'active' : ''}`}
            onClick={() => setCurrentIndex(index)}
          ></span>
        ))}
      </div>
    </div>
  );
};

export default ImageSlider;
